import React, {useCallback} from 'react';
import '../VendorSettings.scss';
import numberToAlphabet from '../../../../../scripts/lib/numberToAlphabet';
import Switch, {SwitchColor} from "../../../../Switch/Switch";

const Vendor = ({index, vendor, labels, states, handlers}) => {

    const handleClick = (e) => {
        const header = e.currentTarget.querySelector('.vendor-header');
        if (header.contains(e.target)) handlers.onClick();
    }

    const VendorInfo = useCallback(() => {// callback?
        const {
            privacyUrl: privacyUrlLabel,
            purposes: purposesLabel,
            specialPurposes: specialPurposesLabel,
            features: featuresLabel,
            specialFeatures: specialFeaturesLabel,
            legitimateInterest: legIntLabel
        } = labels;

        return (
            <div className="vendor-info">
                <div className="label">{privacyUrlLabel}</div>
                <div className="data">
                    <a href={vendor.policyUrl} target="_blank" rel="noopener noreferrer">
                        <span className="icon-external-link"/>
                    </a>
                </div>
                <div className="label">{purposesLabel}</div>
                <div className="data">{vendor.purposes.join(', ')}</div>
                <div className="label">{specialPurposesLabel}</div>
                <div className="data">{numberToAlphabet(vendor.specialPurposes).join(', ')}</div>
                <div className="label">{featuresLabel}</div>
                <div className="data">{vendor.features.join(', ')}</div>
                <div className="label">{specialFeaturesLabel}</div>
                <div className="data">{numberToAlphabet(vendor.specialFeatures).join(', ')}</div>
                <div className="label">{legIntLabel}</div>
                <div className="data">{vendor.legIntPurposes.join(', ')}</div>
            </div>
        );
    }, [labels, vendor.features, vendor.legIntPurposes, vendor.policyUrl, vendor.purposes, vendor.specialFeatures, vendor.specialPurposes])

    return (
        <div className={`vendor${states.isActive ? ' active' : ''}`} onClick={handleClick} key={`vendor_${index}`}>
            <div className="vendor-header">
                <span className="vendor-name">{vendor.name}</span>
                <Switch changeHandler={handlers.onConsent} isChecked={states.isConsented}
                        color={SwitchColor.GREEN} dataTags={{'data-vendor-id': vendor.id}}/>
                {vendor.legIntPurposes.length ?
                    <Switch changeHandler={handlers.onObject} isChecked={states.isObjected}
                            color={SwitchColor.ORANGE} dataTags={{'data-leg-int-id': vendor.id}}/> : null}
            </div>
            <VendorInfo/>
        </div>
    );
}

export default Vendor;